import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CabinWoodsLogo from "../../Assets/CabinWoods/Logo.png";

export default function Navigation() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const [navbarStyle, setNavbarStyle] = useState({
    backgroundColor: "transparent",
  });

  const closeMenu = () => {
    setShow(false);
  };

  // Na klik otiđi skroz gore (smooth)
  const handleClick = (path, id = null) => {
    closeMenu();

    if (id) {
      // Ako ID postoji, navigiraj na "path" i zatim skrolaj na ID
      navigate(path);
      setTimeout(() => {
        const element = document.querySelector(id);
        if (element) {
          const offset = 80; // Visina navigacije
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 0);
    } else {
      // Klasična navigacija
      navigate(path);
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY / window.innerHeight;
      if (scrolled >= 0.25) {
        setNavbarStyle({
          background: "linear-gradient(#000000, #000000a1)",
        });
      } else {
        setNavbarStyle({
          backgroundColor: "transparent",
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav id="navigation" style={navbarStyle}>
      <div
        className={show ? "hamburger active" : "hamburger"}
        onClick={() => setShow(!show)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
      <div>
        <ul className={show ? "nav-links active" : "nav-links"}>
          <li>
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/")}
            >
              Naslovna
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/", "#home-about")}
            >
              Koliba "Lika"
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/", "#sadrzaj")}
            >
              Sadržaji
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/", "#lokacija")}
            >
              Lokacija
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/", "#istrazi")}
            >
              Istraži okolinu
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/rezervacija"
              onClick={() => handleClick("/rezervacija")}
            >
              Rezervacija
            </Link>
          </li>
          <li>
            <Link
              className="navbar-links"
              to="/galerija"
              onClick={() => handleClick("/galerija")}
            >
              Galerija
            </Link>
          </li>
          <li>
            {" "}
            <Link
              className="navbar-links"
              to="/"
              onClick={() => handleClick("/", "#lokacija")}
            >
              Kontakt
            </Link>
          </li>

          <div className="social-links">
            <Link to="/" onClick={closeMenu}>
              <i className="fi fi-brands-instagram"></i>
            </Link>
            <Link to="/" onClick={closeMenu}>
              <i className="fi fi-brands-facebook"></i>
            </Link>{" "}
            <Link to="/" onClick={closeMenu}>
              <i className="fi fi-brands-tik-tok"></i>
            </Link>
          </div>
        </ul>
      </div>
      <Link to="/" onClick={() => handleClick("/")}>
        <img
          className="navigation-logo"
          src={CabinWoodsLogo}
          alt="Cabin Woods Logo"
        />
      </Link>
      <Link className="book-btn" to="/" onClick={closeMenu}>
        Book Now
      </Link>
    </nav>
  );
}
